<template>
  <AppView padd-bottom>
    <TopNav
      slot="top-app-view"
      title=""
      title-class="tw-mr-auto"
      type="menu"
      @input="openSideNav()"
      show-notification-icon
    />
    <div class="mx-body">
      <transition name="fade" mode="out-in" appear>
        <div v-if="error" class="tw-text-center">
          <p class="tw-text-xs opacity-54 tw-py-18 tw-text-center" v-html="error"></p>
        </div>
        <div v-else-if="loading">
          <p class="tw-text-xs opacity-54 tw-py-18 tw-text-center tw-py-10">Finding available mentors...</p>
        </div>
        <div v-else class="tw-overflow-auto">
          <h2 class="tw-text-app-deep-blue font-title tw-text-xl tw-my-1 tw-text-center">Available Mentors</h2>
          <template v-for="(mentor, index) in mentorsList">
            <div
              :key="index"
              class="tw-mt-4"
            >
              <div class="tw-relative tw-block tw-w-full tw-max-w-xs tw-mx-auto tw-text-center">
                <UserPhoto
                  :photo="mentor.photo"
                  class="tw-inline-block"
                  :user-name="mentor"
                />
                <h4 class="tw-text-center tw-font-normal tw-text-xl leading-24">{{ mentor.name }} {{ mentor.middle }}</h4>
                <p class="tw-text-sm tw-text-center opacity-54 tw-text-black tw-mt-2 tw-mr-2 leading-19 tw-px-2 tw-inline-block">
                  Profession: <b>{{ mentor.profession.profession }}</b>
                </p>
                <p class="tw-text-sm tw-text-center opacity-54 tw-text-black tw-mt-2 leading-19 tw-px-2 tw-inline-block">
                  Experience: <b>{{ mentor.experience.experience }} years</b>
                </p>
                <br>
                <p
                  v-if="mentor.bio"
                  class="tw-text-base tw-text-center opacity-78 tw-text-black tw-mt-2 leading-19 h-60 tw-overflow-hidden"
                >
                  {{ mentor.bio }}
                </p>
                <div v-else>
                  <p class="tw-text-sm tw-text-center opacity-54 tw-text-black leading-19 tw-pt-2">
                    availability
                  </p>
                  <p
                    class="tw-text-xs tw-mr-2 tw-text-center opacity-54 tw-text-white leading-19 tw-bg-gray-700 tw-rounded-full tw-px-2 tw-inline-block"
                    v-for="(availability, index) in mentor.availabilities"
                    :key="index"
                  >
                    {{ availability.availability }}
                  </p>

                </div>
                <div class="tw-flex --tw-justify-between tw-justify-end tw-py-4">
                  <BaseButton
                    @click="sendMentorRequest(mentor.id)"
                    text="Send Request"
                    class="tw-bg-gray-200 tw-hidden"
                  />
                  <BaseButton
                    :to="`/app/mentor/${mentor.id}/bio`"
                    text="Full Profile"
                    icon
                    icon-right
                  >
                    <svg class="my-btn__icon" slot="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
                      <path d="M16,67.8c0-1.2,0.4-2,1.2-2.9l29-29l-29-29c-1.6-1.6-1.6-4.1,0-5.7c1.6-1.6,4.1-1.6,5.7,0l31.9,31.9c1.6,1.6,1.6,4.1,0,5.7
                        L22.9,70.8c-1.6,1.6-4.1,1.6-5.7,0C16.4,69.9,16,69,16,67.8z"/>
                    </svg>
                  </BaseButton>
                </div>
                <div class="tw-border opacity-18 tw-w-full tw-mt-6"></div>
              </div>
            </div>
          </template>
        </div>
      </transition>
    </div>
  </AppView>
</template>

<script>

export default {
  name: 'RequestedMentorsList',
  data() {
    return {
      mentorsList: [],
      loading: true,
      error: undefined,
    };
  },
  computed: {
    hasMentors() {
      return this.mentorsList.length > 0;
    },
  },
  methods: {
    sendMentorRequest(mentorId) {
      // apiPost
      console.log(mentorId);
    },
  },
  created() {
    this.$store.commit('isFlatView', false);
    this.$store.dispatch('newMentorsRequestList')
      .catch((err) => {
        const errorMessage = 'Error in getting information of your mentors';
        console.error(errorMessage, err);
        this.$toasted.global.appError({ errorMessage });
        this.error = errorMessage;
      })
      .then((mentors) => {
        if (!mentors) return false;

        this.mentorsList = mentors;

        if (this.mentorsList.length > 0) {
          this.error = undefined;
        } else {
          this.error = `
          Currently there are no mentors available.
          <br>
          Try choosing different goals
          <br>
          <br>
          <br>
          <a href="/app/settings/" class="tw-px-4 tw-py-2 tw-mt-4 tw-border tw-border-gray-900 tw-rounded-sm tw-uppercase bg-black-11">My Goals</a>
          `;
        }

        this.loading = false;

        return mentors;
      });
  },
};
</script>

<style>

</style>
